import { render, staticRenderFns } from "./RecentIcon.vue?vue&type=template&id=b5fc10b4&scoped=true&"
import script from "./RecentIcon.vue?vue&type=script&lang=js&"
export * from "./RecentIcon.vue?vue&type=script&lang=js&"
import style0 from "./RecentIcon.vue?vue&type=style&index=0&id=b5fc10b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fc10b4",
  null
  
)

export default component.exports